'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SemiprivateToggle = require('./components/SemiprivateToggle.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SemiprivateToggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/semi-private-toggle/index.js
// module id = 1339
// module chunks = 0